<div class="card shadow-sm mt-5">
  <!-- Section Tabs -->
  <div class="card-header card-header-primary shadow">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" role="tablist">
          <li
            class="nav-item"
            v-for="(section, index) in current_sections"
            :key="section.id"
            :class="{ active: active_section_tab === index }"
          >
            <a
              class="text-white text-decoration-none nav-link text-xxs"
              @click="change_section_tab(index)"
            >
              {{ section.name }}
              <span v-if="section.is_mandatory" class="ms-1">*</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Current Section Content -->
  <div class="card-body">
    <div v-if="current_sections[active_section_tab]" class="form-container">
      <div class="form-section mb-4 p-3 border rounded-lg shadow">
        <!-- Dynamic Form Fields - Compact Layout -->
        <div class="d-flex flex-column gap-2 w-100">
          <template v-for="field in current_sections[active_section_tab].fields">
            <!-- Text Input -->
            <div v-if="field.type === 'text'">
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              
              <input 
                type="text" 
                class="form-control form-control-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                v-model="field.value"
                :readonly="!current_sections[active_section_tab].editing"
                :placeholder="field.placeholder || ''"
                :required="field.required"
              >
            </div>

            <!-- Email Input -->
            <div v-if="field.type === 'email'">
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <input 
                type="email" 
                class="form-control form-control-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                v-model="field.value"
                :readonly="!current_sections[active_section_tab].editing"
                :placeholder="field.placeholder || ''"
                :required="field.required"
              >
            </div>

            <!-- Date Input -->
            <div v-if="field.type === 'date'">
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <input 
                type="date" 
                class="form-control form-control-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                v-model="field.value"
                :readonly="!current_sections[active_section_tab].editing"
                :required="field.required"
              >
            </div>

            <!-- Number Input -->
            <div v-if="field.type === 'number'">
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <input 
                type="text" 
                @input="handleNumberInput($event, field)"
                class="form-control form-control-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                :value="field.value || ''"
                :readonly="!current_sections[active_section_tab].editing"
                :placeholder="field.placeholder || ''"
                :required="field.required">
            </div>

            <!-- Textarea -->
            <div v-if="field.type === 'textarea'" >
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <textarea 
                class="form-control form-control-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                v-model="field.value"
                :readonly="!current_sections[active_section_tab].editing"
                :rows="field.rows || 2"
                :required="field.required"
              ></textarea>
            </div>

            <!-- Select Dropdown -->
            <div v-if="field.type === 'select'">
              <label :for="field.id" class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <select 
                class="form-select form-select-sm text-xxs bg-light shadow-sm w-50" 
                :id="field.id" 
                v-model="field.value"
                :disabled="!current_sections[active_section_tab].editing"
                :required="field.required"
              >
                <option 
                  v-for="option in field.options" 
                  :value="option.value"
                  :selected="option.value === field.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>

            <!-- Checkbox Group -->
            <div v-if="field.type === 'checkbox-group'">
              <label class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <div 
                v-for="(option, index) in field.options" 
                class="form-check"
              >
                <input 
                  class="form-check-input form-check-input-sm text-xxs mt-2" 
                  type="checkbox" 
                  :id="`${field.id}-${index}`"
                  v-model="option.checked"
                  :disabled="!current_sections[active_section_tab].editing"
                >
                <label class="form-check-label text-xxs" :for="`${field.id}-${index}`">
                  {{ option.text }}
                </label>
              </div>
            </div>

            <!-- Radio Group -->
            <div v-if="field.type === 'radio-group'" class="w-100">
              <label class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <div 
                v-for="(option, index) in field.options" 
                class="form-check"
              >
                <input 
                  class="form-check-input form-check-input-sm text-xxs mt-2" 
                  type="radio" 
                  :name="field.id"
                  :id="`${field.id}-${index}`"
                  v-model="field.value"
                  :value="option.value"
                  :disabled="!current_sections[active_section_tab].editing"
                  :required="field.required"
                >
                <label class="form-check-label text-xxs" :for="`${field.id}-${index}`">
                  {{ option.text }}
                </label>
              </div>
            </div>
            <div v-if="field.type === 'link'">
              <label class="form-label text-xxs fw-bold">{{ field.label }}</label>
              <div>
                <a :href="field.url" target="_blank" class="d-flex align-items-center text-xxs">
                  {{ field.file_name }}
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</div>